import PlannerPage from "@/pages/planner"
import { Navigate, type RouteObject } from "react-router-dom"

const routes: RouteObject = {
  path: "planner",
  element: <PlannerPage />,
  children: [
    {
      path: "*",
      element: <Navigate to="planner" replace />,
    },
  ],
}

export default routes
